import { Navigate, Outlet, useParams } from 'react-router-dom';

import { AuthConsumer, AuthProvider } from '../../contexts/auth-context';
import { WebsocketProvider } from '../../contexts/websocket-context';
import { NotificationsProvider } from '../notification/pages/context';
import { CarrierPortalCarrierProvider } from './CarrierPortalCarrierContext';
import { CarrierPortalDashboard } from './CarrierPortalDashboard';

export const CarrierPortalWrapper = () => {
  const { carrierId: _carrierId } = useParams<{ carrierId: string }>();
  const parsedCarrierId = +_carrierId!;
  if (isNaN(parsedCarrierId)) {
    return <Navigate to="/carrier-portal" replace />;
  }

  return (
    <AuthProvider fallbackLogin="/portal/login">
      <AuthConsumer>
        {(auth) => {
          if (!auth?.me) {
            return <Navigate to="/portal/login" replace />;
          }

          if (auth.me.isInternal) {
            return <Navigate to="/internal" replace />;
          }

          if (auth.me.carriers.some((c) => c.id === parsedCarrierId)) {
            return null;
          } else {
            return <Navigate to="/carrier-portal/select" replace />;
          }
        }}
      </AuthConsumer>

      <WebsocketProvider>
        <NotificationsProvider>
          <CarrierPortalCarrierProvider carrierId={parsedCarrierId}>
            <CarrierPortalDashboard>
              <Outlet />
            </CarrierPortalDashboard>
          </CarrierPortalCarrierProvider>
        </NotificationsProvider>
      </WebsocketProvider>
    </AuthProvider>
  );
};
